import UntrustedDeviceChoiceForm from './UntrustedDeviceChoiceForm';

export default UntrustedDeviceChoiceForm;